import { render, staticRenderFns } from "./CourierEdit.vue?vue&type=template&id=481e96e6&scoped=true&"
import script from "./CourierEdit.vue?vue&type=script&lang=js&"
export * from "./CourierEdit.vue?vue&type=script&lang=js&"
import style0 from "./CourierEdit.vue?vue&type=style&index=0&id=481e96e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e96e6",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
